import React, { FC, useEffect, useRef, useState } from "react";
import SuccessToast from "../../cards/toast";
import { useTranslate } from "@tolgee/react";
import { Form } from "react-bootstrap";
import { Tooltip } from "bootstrap";
import Editors from "./editors";
import { useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../pages/lomavisCreator";
import {
  ALL,
  PLATFORM_LIST,
  PLATFORM_LIST_NAMES,
} from "../../../../config/constants";
import { POST_TYPE_KEY, platformFeatures } from "../../config/platformFeatures";
import { PLATFORM_COLORS, PLATFORM_ICONS } from "../../../../config/icons";
import {
  AddImageButton,
  EditorHeader,
  UseTemplateButton
} from "../sharedComponents";
import toast from "react-hot-toast";
import EditorTitle from "../commonElements/editorTitle";
import VideoModifier from "./videoModifier";
import { IMAGE, VIDEO } from "../../config/constants";
import ToggleConfirmation from "../../cards/sychEditToggleConfirmation";

interface Props {
  handleClose: Function;
  platform: string;
  newUploadedAsset: any;
  count: Number;
  handleCloseNoConfirmation: Function;
  /** Opens the overlay picker for the image on screen, naming it by uuid. */
  onUseTemplate: (media: { uuid: string; platform: string }) => void;
  canUseTemplate: boolean;
  /** False on plans without overlays: the button shows, wearing a lock. */
  overlaysAvailable?: boolean;
}
const MultiImageModifier: FC<Props> = ({
  handleClose,
  platform,
  newUploadedAsset,
  count,
  handleCloseNoConfirmation,
  onUseTemplate,
  canUseTemplate,
  overlaysAvailable = true
}) => {
  const { t } = useTranslate();
  const [synchronousEditing, setSynchronousEditing] = useState(true);
  const [startSubmission, setStartSubmission] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);
  const [totalItemsInUpload, setTotalItemsInUpload] = useState(
    newUploadedAsset?.length
  );
  const [showConfirmation, setShowConfirmation] = useState(false);
  const fileInputRef = useRef(null);
  const divRef = useRef<HTMLDivElement>(null);
  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );
  const postData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData
  );
  const allEnabledPlatforms = PLATFORM_LIST.filter(
    (item) => platformEnabled[item] === true
  );
  const typeKey = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postTypeSelected
  );

  const postTypeRule = (platform) => {
    return platformFeatures[platform][POST_TYPE_KEY]?.find(
      (pt) => pt.typeKey === typeKey[platform]
    );
  };

  const postMediaData = (platform) => {
    return postData[platform].media
      ?.filter((file) => file.media_type === "image")
      .slice(-1)[0];
  };
  const [editorArrayInfo, setEditorArrayInfo] = useState(
    platform === ALL
      ? allEnabledPlatforms.map((platform) => {
          return {
            platform: platform,
            aspectRatio: 1,
            name: PLATFORM_LIST_NAMES?.[platform],
            editorRef: useRef(null),
            fileInputRef: useRef(null),
            newEdit: {},
            imageInfo: newUploadedAsset,
            count: count,

            maxImages: postTypeRule(platform).mediaTypes.image.enabled
              ? postTypeRule(platform).mediaTypes.image.maxFiles
              : null,

            cropSuggestions:
              postTypeRule(platform)?.mediaTypes.image?.cropSuggestions,

            defaultCropRatio:
              postTypeRule(platform)?.mediaTypes.image?.defaultCropRatio,

            initialLoad: false,
          };
        })
      : [
          {
            platform: platform,
            aspectRatio: 1,
            name: PLATFORM_LIST_NAMES?.[platform],
            editorRef: useRef(null),
            fileInputRef: useRef(null),
            newEdit: {},
            imageInfo: newUploadedAsset,
            maxImages: postTypeRule(platform).mediaTypes.image.enabled
              ? postTypeRule(platform).mediaTypes.image.maxFiles
              : null,
            count: count,
            cropSuggestions:
              postTypeRule(platform)?.mediaTypes.image?.cropSuggestions,

            defaultCropRatio:
              postTypeRule(platform)?.mediaTypes.image?.defaultCropRatio,
            initialLoad: false,
          },
        ]
  );

  const updateCurrentCrop = (platform, newCropRatio) => {
    setEditorArrayInfo((prevInfo) =>
      prevInfo.map((item) =>
        item.platform === platform
          ? { ...item, defaultCropRatio: newCropRatio, initialLoad: true }
          : item
      )
    );
  };

  //   const EditorArrayInfo =
  //     platform === ALL
  //       ? allEnabledPlatforms.map((platform) => {
  //           return {
  //             platform: platform,
  //             aspectRatio: 1,
  //             name: PLATFORM_LIST_NAMES?.[platform],
  //             editorRef: useRef(null),
  //             newEdit: {},
  //             imageInfo: newUploadedAsset,
  //             maxImages: postTypeRule(platform).mediaType.image.enabled
  //               ? postTypeRule(platform).mediaType.image.maxFiles
  //               : null,

  //             cropSuggestions:
  //               postTypeRule(platform).mediaType.image?.cropSuggestions,

  //             defaultCropRatio:
  //               postTypeRule(platform).mediaType.image?.cropSuggestions[0],
  //           };
  //         })
  //       : [
  //           {
  //             platform: platform,
  //             aspectRatio: 1,
  //             name: PLATFORM_LIST_NAMES?.[platform],
  //             editorRef: useRef(null),
  //             newEdit: {},
  //             imageInfo: newUploadedAsset,
  //             maxImages: postTypeRule(platform).mediaType.image.enabled
  //               ? postTypeRule(platform).mediaType.image.maxFiles
  //               : null,

  //             cropSuggestions:
  //               postTypeRule(platform).mediaType.image?.cropSuggestions,

  //             defaultCropRatio:
  //               postTypeRule(platform).mediaType.image?.cropSuggestions[0],
  //           },
  //         ];

  const triggerSuccessToast = () => {
    toast.success(t("lomavisCreator.image.saved"), {
      position: "top-right",
      id: "accounts.invites.table.invite_deleted",
    });
  };

  const editCountTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t("lomavisCreator.edit_count_tooltip")}
              </div>
            </div></div>'`;
  const syncEditTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t("lomavisCreator.sync_edit_tooltip")}
              </div>
            </div></div>'`;
  useEffect(() => {
    const editCountTooltipTrigger = document.querySelector(
      ".edit_count-tooltip-trigger"
    );
    const syncEditTooltipTrigger = document.querySelector(
      ".sync_edit-tooltip-trigger "
    );
    editCountTooltipTrigger &&
      new Tooltip(editCountTooltipTrigger, {
        title: "title",
        placement: "auto",
        trigger: "hover",
        container: "body",
        template: editCountTooltip,
      });
    syncEditTooltipTrigger &&
      new Tooltip(syncEditTooltipTrigger, {
        title: "title",
        placement: "auto",
        trigger: "hover",
        container: "body",
        template: syncEditTooltip,
      });
  }, []);

  const scrollToTop = () => {
    if (divRef.current) {
      // Manually scroll to the top
      divRef.current.scrollTop = 0;
    }
  };
  return (
    <div className="d-flex flex-column w-100 h-100 gap-4 justify-content-between">
      <SuccessToast show={showToast} onClose={() => setShowToast(false)} />
      <div
        style={{ overflowY: "auto" }}
        ref={divRef}
        className="h-100 w-100 gap-4 d-flex flex-column flex-fill "
      >
        <EditorHeader>
          {" "}
          {startSubmission ? (
            <div className="h-100 w-100 d-flex justify-content-start align-items-center gap-3">
              {editorArrayInfo.map((editor) => (
                <i
                  className={PLATFORM_ICONS[editor.platform] + " fs-1 me-2"}
                  style={{
                    color: PLATFORM_COLORS[editor.platform],
                  }}
                ></i>
              ))}
            </div>
          ) : (
            <div className="h-100 w-100 d-flex justify-content-between align-items-center">
              {" "}
              <div
                style={{ flex: 1 }}
                className="p-3 d-flex gap-1 align-items-center"
              >
                <div className="d-flex gap-1 align-items-center">
                  <EditorTitle title={"sync_editing"} toolTip={true} />
                </div>
                <div className="d-flex align-items-center">
                  <Form.Check
                    style={{
                      cursor: "pointer",
                      transform: "scale(0.8)",
                    }}
                    className="fs-4 pt-2"
                    type="switch"
                    id="use-seperate-publication "
                    checked={synchronousEditing}
                    onChange={() => {
                      if (synchronousEditing) {
                        setSynchronousEditing(false);
                      } else if (!synchronousEditing) {
                        setShowConfirmation(true);
                      }
                    }}
                  />
                </div>
              </div>
              <div
                style={{ flex: 1 }}
                className=" d-flex align-items-center justify-content-center gap-2"
              >
                <h3>
                  {currentAssetIndex + 1}/{totalItemsInUpload}
                </h3>
                <i
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    padding: "0",
                    margin: "0",
                  }}
                  className="fa-duotone fa-circle-info edit_count-tooltip-trigger "
                  data-bs-toggle="tooltip"
                ></i>
              </div>
              <div
                style={{ flex: 1 }}
                className="d-flex justify-content-end align-item-center gap-2"
              >
                {canUseTemplate &&
                  synchronousEditing &&
                  newUploadedAsset[currentAssetIndex]?.media_type !== VIDEO && (
                    <>
                      <UseTemplateButton
                        handleClick={() =>
                          onUseTemplate({
                            uuid: newUploadedAsset[currentAssetIndex]?.uuid,
                            platform
                          })
                        }
                        disabled={startSubmission}
                        isAvailable={overlaysAvailable}
                      />
                      <AddImageButton
                        handleClick={() => fileInputRef.current?.click()}
                        disabled={startSubmission}
                      />
                    </>
                  )}
              </div>
            </div>
          )}
        </EditorHeader>

        <div className="d-flex w-100 h-100 gap-4">
          {newUploadedAsset[currentAssetIndex]?.media_type === IMAGE ? (
            <Editors
              EditorArrayInfo={editorArrayInfo}
              updateCurrentCrop={updateCurrentCrop}
              synchronousEditing={synchronousEditing}
              setSynchronousEditing={setSynchronousEditing}
              fileInputRef={fileInputRef}
              setStartSubmission={setStartSubmission}
              startSubmission={startSubmission}
              successNotification={() => triggerSuccessToast()}
              handleClose={handleClose}
              handleCloseNoConfirmation={handleCloseNoConfirmation}
              setCurrentIndex={setCurrentAssetIndex}
              currentIndex={currentAssetIndex}
              totalItemsInUpload={totalItemsInUpload}
              scrollToTop={scrollToTop}
            />
          ) : newUploadedAsset[currentAssetIndex]?.media_type === VIDEO ? (
            <VideoModifier
              handleClose={handleClose}
              platform={platform}
              handleCloseNoConfirmation={handleCloseNoConfirmation}
              newUploadedAsset={newUploadedAsset}
              count={count}
              setCurrentIndex={setCurrentAssetIndex}
              currentIndex={currentAssetIndex}
              totalItemsInUpload={totalItemsInUpload}
              scrollToTop={scrollToTop}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      <ToggleConfirmation
        show={showConfirmation}
        handleClose={() => setShowConfirmation(false)}
        handleClear={() => setSynchronousEditing(true)}
      />
    </div>
  );
};

export default MultiImageModifier;
